<template>
    <div class="project-payout-summary">
        <div class="chart-area">
            <v-chart ref="pieChart" :option="chartOption" style="width: 400px; height: 300px; margin-bottom: 20px;" />
        </div>
        <div class="table-area">
            <el-table
                class="ah-el-data-table data-table"
                :data="payoutItems"
                empty-text="沒有項目"
                size="small"
                :key="'payout-items-summary-table'"
                :summary-method="getSummaries"
                show-summary
            >
                <el-table-column type="index" width="45"> </el-table-column>
                <el-table-column prop="name" label="支出項目">
                    <template slot-scope="scope">
                        <span class="payout-item-label">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="數量" width="100" align="right"></el-table-column>
                <el-table-column prop="amt" label="金額" align="right" width="110">
                    <template slot-scope="scope">
                        <Money :v="scope.row.amt" />
                    </template>
                </el-table-column>
                <el-table-column label="幣別" width="70">TWD</el-table-column>
                <el-table-column prop="percent" label="%" width="80" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.percent }} %
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    props: {
        payouts: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    components: {
    },
    data() {
        return {
            chartOption: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: [],
                    show: false,
                },
                series: [
                    {
                        name: '支出',
                        type: 'pie',
                        radius: ['00%', '55%'],
                        center: ['50%', '50%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            },
        };
    },
    computed: {
        payoutItems() {
            const summaryList = [];
            if (!this.payouts || this.payouts.length === 0) {
                return summaryList;
            }
            let total = 0;
            this.payouts.forEach((payout) => {
                const itemSno = payout.iteM_SNO;

                // 有支出項目才統計
                if (itemSno) {
                    // 取得統計的支出項目物件
                    let summaryItem = summaryList.find((x) => x.sno === itemSno);

                    // 如尚未建立，則新增該物件
                    if (!summaryItem) {
                        summaryItem = {
                            sno: itemSno,
                            name: itemSno ? payout.iteM_NAM : '（未編列項目）',
                            amt: 0,
                            count: 0,
                            percent: 0,
                        };
                        summaryList.push(summaryItem);
                    }

                    // 加總金額
                    const amt = Math.round(payout.amt * payout.paY_CNYRAT);
                    summaryItem.amt += amt;
                    total += amt;

                    // 加總數量
                    summaryItem.count += 1;
                }
            });

            // 計算百分比
            for (let i = 0; i < summaryList.length; i += 1) {
                summaryList[i].percent = ((summaryList[i].amt / total) * 100).toFixed(1);
            }
            // 排序
            summaryList.sort((a, b) => b.amt - a.amt);

            return summaryList;
        },
        pieChartOption() {
            return {
                series: [
                    {
                        type: 'pie',
                        radius: ['48%', '83%'],
                        center: ['50%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                        },
                        data: [],
                    },
                ],
            };
        },
    },
    mounted() {
        this.updateCharts();
    },
    methods: {
        getSummaries(param) {
            const { data } = param;
            const sums = [];
            sums[0] = '';
            sums[1] = '合計';
            sums[2] = data.reduce((acc, obj) => acc + obj.count, 0);
            sums[3] = data.reduce((acc, obj) => acc + obj.amt, 0).toLocaleString();
            sums[4] = 'TWD';
            sums[5] = '100 %';
            return sums;
        },
        updateCharts() {
            const seriesData = [];

            this.payoutItems.forEach((item) => {
                seriesData.push({
                    name: item.name,
                    value: Math.round(item.amt),
                });
            });
            this.chartOption.series[0].data = seriesData;
        },
    },
};
</script>
<style lang="scss">
.project-payout-summary {
    display: flex;
    margin-bottom: 20px;

    .chart-area {
        width: 400px;
    }

    .table-area {
        flex-grow: 1;
    }

    .ah-el-data-table.el-table td,th {
        font-size: 10pt;
    }

    .payout-item-label {
        display: inline-block;
        padding: 0px 6px;
        border-radius: 5px;
        font-size: 9pt;
        background-color: #eee;
        color: #666;
        cursor: default;
    }
}
</style>
